import React, { useContext, useEffect, useState } from 'react'
import { UserContext } from '../../wrappers/UserContext'
import { Redirect } from 'react-router-dom'
import { checkRole, getRoles } from '../../../utils/user/permissions'
import urls from '../../../utils/constants/urls'
import withConfig from '../../wrappers/withConfig'

const RestrictedAccess = withConfig(({ allowedRoles, config, children }) => {
    const { client } = useContext(UserContext)
    const [hasAccess, setHasAccess] = useState(true)
    const { USE_AUTHENTICATION } = config

    useEffect(() => {
        const checkClientAccess = async allowedRoles => {
            await client.getUser().then(user => {
                const roles = getRoles(user)
                if (allowedRoles.some(role => checkRole(role, roles))) {
                    setHasAccess(true)
                } else {
                    setHasAccess(false)
                }
            })
        }
        if (USE_AUTHENTICATION) {
            checkClientAccess(allowedRoles)
        }
    }, [client, allowedRoles, USE_AUTHENTICATION])
    
    if (hasAccess) {
        return children
    } else {
        return <Redirect to={urls.login} />
    }
})

export default RestrictedAccess